import { functions } from 'helpers/functions';
import { combineReducers } from 'redux';

let connect: any = {
  active: true,
  description: null,
  autoresponder: null,
};

const modalNewConnect = (state = false, action: any) => {
  switch (action.type) {
    case 'OPEN_MODAL_NEW_CONNECT':
      return true;
    case 'CLOSE_MODAL_NEW_CONNECT':
      return false;
    default:
      return state;
  }
};

const modalEditAction = (state = false, action: any) => {
  switch (action.type) {
    case 'OPEN_MODAL_EDIT_ACTION':
      return true;
    case 'CLOSE_MODAL_EDIT_ACTION':
      return false;
    default:
      return state;
  }
};

const currentConnect = (state: any = null, action: any) => {
  switch (action.type) {
    case 'CHANGE_CURRENT_CONNECT':
      return Object.assign({}, action.connect);
    case 'CLEAN_CURRENT_CONNECT':
      return null;
    default:
      return state;
  }
};

const newConnect = (state = connect, action: any) => {
  switch (action.type) {
    case 'CHANGE_NEW_CONNECT':
      return Object.assign({}, action.newConnect);
    case 'RESET_NEW_CONNECT':
      return Object.assign({}, action.newConnect);
    default:
      return state;
  }
};

const step = (currentStep = 0, action: any) => {
  switch (action.type) {
    case 'NEXT_STEP':
      return currentStep + 1;
    case 'PREVIOUS_STEP':
      return currentStep === 0 ? currentStep : currentStep - 1;
    case 'RESET_STEP':
      return 0;
    default:
      return currentStep;
  }
};

const stepAction = (currentStep = 0, action: any) => {
  switch (action.type) {
    case 'NEXT_STEP_ACTION':
      return currentStep + 1;
    case 'PREVIOUS_STEP_ACTION':
      return currentStep === 0 ? currentStep : currentStep - 1;
    case 'RESET_STEP_ACTION':
      return 0;
    default:
      return currentStep;
  }
};

const optionsAction = (state = {}, action: any) => {
  switch (action.type) {
    case 'ADD_NEW_OPTION_ACTION':
      let newState = functions.cloneDeep(state);

      newState[action.newOption.field] = action.newOption.value;

      return functions.cloneDeep(newState);
    case 'RESET_OPTIONS_ACTION':
      return {};
    case 'RESET_OPTION_ACTION':
      return functions.cloneDeep(functions.omit(state, action.field));
    default:
      return state;
  }
};

let daction: any = {
  active: true,
  description: null,
  trigger_id: null,
  option_id: null,
  fields: {},
  options_parameters: {},
};

const newAction = (state = Object.assign({}, daction), action: any) => {
  switch (action.type) {
    case 'CHANGE_NEW_ACTION':
      return Object.assign({}, action.newAction);
    case 'RESET_NEW_ACTION':
      return Object.assign({}, daction);
    default:
      return state;
  }
};

const modalNewAction = (state = false, action: any) => {
  switch (action.type) {
    case 'OPEN_MODAL_NEW_ACTION':
      return true;
    case 'CLOSE_MODAL_NEW_ACTION':
      return false;
    default:
      return state;
  }
};

const currentAction = (state: any = daction, action: any) => {
  switch (action.type) {
    case 'CHANGE_CURRENT_ACTION':
      return Object.assign({}, action.action);
    case 'CLEAN_CURRENT_ACTION':
      return null;
    default:
      return state;
  }
};

export const reducer = combineReducers({
  newConnect,
  currentConnect,
  step,
  modalNewConnect,
  newAction,
  currentAction,
  modalNewAction,
  modalEditAction,
  stepAction,
  optionsAction,
});
